enum Actions {
  // action types
  ADD_BODY_CLASSNAME = "addBodyClassName",
  REMOVE_BODY_CLASSNAME = "removeBodyClassName",
  ADD_BODY_ATTRIBUTE = "addBodyAttribute",
  REMOVE_BODY_ATTRIBUTE = "removeBodyAttribute",
  ADD_CLASSNAME = "addClassName",
  VERIFY_AUTH = "verifyAuth",
  LOGIN = "login",
  LOGOUT = "logout",
  REGISTER = "register",
  UPDATE_USER = "updateUser",
  FORGOT_PASSWORD = "forgotPassword",
  SET_BREADCRUMB_ACTION = "setBreadcrumbAction",
  GET_SHOPS = "getShops",
  GET_SHOP = "getShop",
  CREATE_SHOP = "createShop",
  UPDATE_SHOP = "updateShop",
  GET_BUDGET_YEARS = "getBudgetYears",
  GET_BUDGET_YEAR = "getBudgetYear",
  GET_BUDGET_YEAR_OPTIONS = "getBudgetYearOptions",
  CREATE_BUDGET_YEAR = "createBudgetYear",
  UPDATE_BUDGET_YEAR = "updateBudgetYear",
  GET_BUDGET_QUARTERS = "getBudgetQuarters",
  GET_BUDGET_QUARTER = "getBudgetQuarter",
  GET_BUDGET_QUARTER_BY_PARAMS = "getBudgetQuarterByParams",
  GET_BUSINESS_DISTRICTS = "getBusinessDistricts",
  GET_BUSINESS_DISTRICT = "getDBusinessistrict",
  CREATE_BUSINESS_DISTRICT = "createBusinessDistrict",
  UPDATE_BUSINESS_DISTRICT = "updateBusinessDistrict",
  GET_ADMINS = "getAdmins",
  GET_ADMIN = "getAdmin",
  CREATE_ADMIN = "createAdmin",
  UPDATE_ADMIN = "updateAdmin",
  DELETE_ADMIN = "deleteAdmin",
  GET_DISTRIBUTION_USERS = "getDistributionUsers",
  GET_DISTRIBUTIONS = "getDistributions",
  GET_DISTRIBUTION = "getDistribution",
  CREATE_DISTRIBUTION = "createDistribution",
  UPDATE_DISTRIBUTION = "updateDistribution",
  SHIFT_BUDGET = "shiftBudget",
  ADD_BUDGET = "addBudget",
  GET_COUPON_ITEMS = "getCouponItems",
  GET_COUPON_ITEM = "getCouponItem",
  CREATE_COUPON_ITEM = "createCouponItem",
  UPDATE_COUPON_ITEM = "updateCouponItem",
  UPDATE_COUPON_ITEM_SHOPS = "updateCouponItemShops",
  DELETE_COUPON_ITEM = "deleteCouponITtem",
  GET_COUPON_DELIVER_EVENTS = "getConponDeliverEvents",
  GET_COUPON_DELIVER_EVENT = "getConponDeliverEvent",
  CREATE_COUPON_DELIVER_EVENT = "createConponDeliverEvent",
  UPDATE_COUPON_DELIVER_EVENT = "updateConponDeliverEvent",
  GET_COUPON_SETTINGS = "getCouponSettings",
  UPDATE_COUPON_SETTINGS = "updateCouponSettings",
  GET_COUPON_DELIVER_EVENT_ITEMS = "getCouponDeliverEventItems",
  UPDATE_COUPON_DELIVER_EVENT_ITEMS = "updateCouponDeliverEventItems",
  GET_USERS = "getUsers",
  GET_ORDERS = "getOrders",
  GET_ORDER = "getOrder",
  GET_ROLES = "getRoles",
  GET_EVENTS = "getEvents",
  GET_EVENT = "getEvent",
  CREATE_EVENT = "createEvent",
  UPDATE_EVENT = "updateEvent",
  UPDATE_SHOP_LOGIN = "updateShopLogin",
  GET_SHOP_LOGIN = "getShopLogin",
  UPDATE_EVENT_ADMINS = "updateEventAdmins",
  SUBMIT_EVENT = "submitEvent",
  SUSPEND_EVENT = "suspend_event",
  APPROVE_EVENT = "approveEvent",
  UPDATE_EVENT_INVITATIONS = "update_event_invitations",
  GET_EVENT_INVITATIONS = "get_event_invitations",
  GET_PENDING_EVENTS = "get_pending_events",
  REQUIRE_EVENT_APPROVE = "require_event_approve",
  REQUIRE_EVENT_DENY = "require_event_deny",
  GET_SHOP_BANNERS = "get_shop_banners",
  GET_USER_BANNERS = "get_user_banners",
  UPDATE_SYSTEM_SETTING = "update_system_setting",
  GET_SYSTEM_SETTING = "get_system_setting",
  UPDATE_EVENT_GIFT_COUPONS = "update_event_gift_coupon",
  GET_GIFT_COUPONS = "get_gift_coupons",
  GET_EVENT_REGISTRATIONS = "get_event_registrations",
  GET_NEWS_ITEMS = "getNewsItems",
  GET_NEWS_ITEM = "getNewsItem",
  CREATE_NEWS_ITEM = "createNewsItem",
  UPDATE_NEWS_ITEM = "updateNewsItem",

  GET_COMPOUND_CATEGORIES = "getCompoundCategories",
  GET_COMPOUND_CATEGORY = "getCompoundCategory",
  CREATE_COMPOUND_CATEGORY = "createCompoundCategory",
  UPDATE_COMPOUND_CATEGORY = "updateCompoundCategory",
  DELETE_COMPOUND_CATEGORY = "deleteCompoundCategory",

  GET_LOTTERY_SIGNS = "getLotterySigns",
  GET_LOTTERY_SIGN = "getLotterySign",
  CREATE_LOTTERY_SIGN = "createLotterySign",
  UPDATE_LOTTERY_SIGN = "updateLotterySign",
  DELETE_LOTTERY_SIGN = "deleteLotterySign",

  GET_COMPOUNDS = "getCompounds",
  GET_COMPOUND = "getCompound",
  CREATE_COMPOUND = "createCompound",
  UPDATE_COMPOUND = "updateCompound",
  DELETE_COMPOUND = "deleteCompound",
  GET_IPS = "getIps",
  GET_IP = "getIp",
  CREATE_IP = "createIp",
  UPDATE_IP = "updateIp",
  DELETE_IP = "deleteIp",
  GET_PRODUCT_BRANDS = "getProductBrands",
  GET_PRODUCT_BRAND = "getProductBrand",
  CREATE_PRODUCT_BRAND = "createProductBrand",
  UPDATE_PRODUCT_BRAND = "updateProductBrand",
  DELETE_PRODUCT_BRAND = "deleteProductBrand",
  GET_ALL_PRODUCTS = "getAllProducts",
  GET_PRODUCTS = "getProducts",
  GET_PRODUCT = "getProduct",
  CREATE_PRODUCT = "createProduct",
  UPDATE_PRODUCT = "updateProduct",
  DELETE_PRODUCT = "deleteProduct",
  ABANDON_PRODUCT = "abandonProduct",
  UPLOAD_PRODUCTS = "uploadProducts",
  GET_DOWNLOAD_PRODUCTS = "getDownloadProducts",
  GET_DOWNLOAD_PAYMENT_RECORDS = "getDownloadPaymentRecords",
  GET_DOWNLOAD_ADD_BALANCE_RECORDS = "getDownloadAddBalanceRecords",
  GET_DOWNLOAD_ADD_POINT_RECORDS = "getDownloadAddPointRecords",
  GET_DOWNLOAD_GIFT_RECORDS = "getDownloadGiftRecords",
  GET_DOWNLOAD_MEMBERS = "getDownloadMembers",
  GET_DOWNLOAD_LOSER_ITEMS = "getDownloadLoserItems",
  GET_BOX_INFOS = "getBoxInfos",
  GET_BOX_INFO = "getBoxInfo",
  GET_BOXES = "getBoxes",
  GET_BOX_RECORDS = "getBoxRecords",
  CREATE_BOX_INFO = "createBoxInfo",
  UPDATE_BOX_INFO = "updateBoxInfo",
  GET_BOX_TYPES = "getBoxTypes",
  GET_GAME_TYPES = "getGameTypes",
  GET_BOX_ITEM_LEVELS = "getBoxItemLevels",
  GET_BOX_ITEM_TYPES = "getBoxItemTypes",
  GET_BOX_LEVEL_TYPES = "getBoxLevelTypes",
  GET_BOX_CATEGORIES = "getBoxCategories",
  GET_BOX_CATEGORY = "getBoxCategory",
  CREATE_BOX_CATEGORY = "createBoxCategory",
  UPDATE_BOX_CATEGORY = "updateBoxCategory",
  DELETE_BOX_CATEGORY = "deleteBoxCategory",
  CREATE_BOXES = "createBoxes",
  UPDATE_BOX_ENABLED = "updateBoxEnabled",

  GET_MEMBERS = "getMembers",
  GET_MEMBER = "getMember",
  UPDATE_MEMBER = "updateMember",
  ADD_MEMBER_BALANCE = "addMemberBalance",
  ADD_MEMBER_POINT = "addMemberPoint",

  GET_REPORT_DAYS = "getReportDays",

  GET_PRODUCT_BRAND_OPTIONS = "getProductBrandOptions",
  GET_PRODUCT_IP_OPTIONS = "getProductIpOptions",
  GET_PRODUCT_RECYCLE_TYPE_OPTIONS = "getProductRecycleTypeOptions",
  GET_BANNERS = "getBanners",
  UPDATE_BANNERS = "updateBanners",
  GET_BOX_INFO_BOX_TYPE_OPTIONS = "getBoxInfoBoxTypeOptions",
  GET_REMOVE_BALANCE_RECORDS = "getRemoveBalanceRecords",
  CREATE_REMOVE_BALANCE_RECORD = "createRemoveBalanceRecord",
  GET_PAYMENT_RECORDS = "getPaymentRecords",
  GET_ADD_BALANCE_RECORDS = "getAddBalanceRecords",
  CREATE_ADD_BALANCE_RECORD = "createAddBalanceRecord",
  GET_OPERATING_COSTS = "getOperatingCosts",
  CREATE_OPERATING_COST = "createOperatingCost",
  UPDATE_OPERATING_COST = "updateOperatingCost",
  DELETE_OPERATING_COST = "deleteOperatingCost",
  GET_OPERATING_COST_MONTHLY_SUMMARY = "getOperatingCostMonthlySummary",
  GET_ADD_POINT_RECORDS = "getAddPointRecords",
  CREATE_ADD_POINT_RECORD = "createAddPointRecord",
  GET_ADD_EXTRA_POINT_RECORDS = "getAddExtraPointRecords",
  CREATE_ADD_EXTRA_POINT_RECORD = "createAddExtraPointRecord",
  ABORT_ADD_POINT_RECORD = "abortAddPointRecord",
  ABORT_ADD_EXTRA_POINT_RECORD = "abortAddExtraPointRecord",
  ABORT_ADD_BALANCE_RECORD = "abortAddBalanceRecord",
  GET_SHIPPING_ORDERS = "getShippingOrders",
  UPDATE_SHIPPING_ORDER = "createShippingOrderAddPointRecord",
  GET_SHIPPING_ORDER = "getShippingOrder",
  GET_SUMMARY = "getSummary",
  GET_WATER_LIST = "getWaterList",
  GET_LOSER_LIST = "getLoserList",
  GET_CARD_RECORDS = "getCardRecords",
  GET_WATER_ITEMS = "getWaterItems",
  GET_LOSER_ITEMS = "getLoserItems",
  CONFIRM_REMOVE_BALANCE_RECORD = "confirmRemoveBalanceRecord",
  ABORT_REMOVE_BALANCE_RECORD = "abortRemoveBalanceRecord",
  GET_EVENT_OPTIONS = "getEventOptions",
  GET_BOX_PRODUCTS = "getBoxProducts",
  GET_LEVELS = "getLevels",
  GET_BOX_LEVEL_ITEM_INFO_GIFT_TYPES = "getBoxLevelItemInfoGiftTypes",
  GET_GIFT_RECORDS = "getGiftRecords",
  GET_GIFT_RECORD = "getGiftRecord",
  CREATE_GIFT_RECORD = "create_gift_record",
  ABORT_GIFT_RECORD = "abortGiftRecord",
  DELETE_DISTRIBUTION = "deleteDistribution",
  DELETE_DISTRIBUTION_USER = "deleteDistributionUser",
  GET_RELATIVE_BOX_INFOS = "getRelativeBoxInfos",
  FETCH_SHIPPING_PRODUCTS = "fetchShippingProducts",
  UPDATE_SHIPPING_PRODUCT = "updateShippingProduct",
  BATCH_DELIVER_SHIPPING_PRODUCTS = "batchDeliverShippingProducts",
  FETCH_POCKET_ITEMS = "FETCH_POCKET_ITEMS",
  FETCH_SHIPPING_RECORDS = "FETCH_SHIPPING_RECORDS",
  UPDATE_SHIPPING_RECORD = "UPDATE_SHIPPING_RECORD",
  CANCEL_SHIPPING_PRODUCT = "cancelShippingProduct",
  DOWNLOAD_SHIPPING_PRODUCTS = "DOWNLOAD_SHIPPING_PRODUCTS",
  DOWNLOAD_SHIPPING_RECORDS = "DOWNLOAD_SHIPPING_RECORDS",
  RETURN_SHIPPING_RECORD = "RETURN_SHIPPING_RECORD",
  GET_COMPOUND_RECORDS = "getCompoundRecords",
  GET_USER_PENDING_DETAILS = "getUserPendingDetails",
  PROCESS_SHIPPING_DATA = "processShippingData",

  // 商城订单相关
  GET_MALL_ORDERS = "getMallOrders",
  GET_MALL_PRODUCTS = "getMallProducts",
  MARK_PRODUCT_ARRIVED = "markProductArrived",
  GET_MALL_ORDER = "getMallOrder",
  UPDATE_MALL_ORDER = "updateMallOrder",
  SHIP_MALL_ORDER = "shipMallOrder",
  DOWNLOAD_MALL_ORDERS = "downloadMallOrders",

  // 商城优惠券相关
  GET_MALL_COUPONS = "getMallCoupons",
  GET_MALL_COUPON = "getMallCoupon",
  CREATE_MALL_COUPON = "createMallCoupon",
  UPDATE_MALL_COUPON = "updateMallCoupon",
  DELETE_MALL_COUPON = "deleteMallCoupon",
  GRANT_MALL_COUPON = "grantMallCoupon",
  GET_MALL_COUPON_USAGE = "getMallCouponUsage",

  // 抽赏优惠券相关
  GET_LOTTERY_COUPONS = "getLotteryCoupons",
  GET_LOTTERY_COUPON = "getLotteryCoupon",
  CREATE_LOTTERY_COUPON = "createLotteryCoupon",
  UPDATE_LOTTERY_COUPON = "updateLotteryCoupon",
  DELETE_LOTTERY_COUPON = "deleteLotteryCoupon",
  GRANT_LOTTERY_COUPON = "grantLotteryCoupon",
  GET_LOTTERY_COUPON_USAGE = "getLotteryCouponUsage",
  GET_LOTTERY_COUPON_BOX_INFOS = "getLotteryCouponBoxInfos",

  // 明信片奖励相关
  GET_POSTCARD_REWARD_CONFIGS = "getPostcardRewardConfigs",
  GET_POSTCARD_REWARD_CONFIG = "getPostcardRewardConfig",
  CREATE_POSTCARD_REWARD_CONFIG = "createPostcardRewardConfig",
  UPDATE_POSTCARD_REWARD_CONFIG = "updatePostcardRewardConfig",
  DELETE_POSTCARD_REWARD_CONFIG = "deletePostcardRewardConfig",
  GET_POSTCARD_REWARD_OPTIONS = "getPostcardRewardOptions",
  SEARCH_POSTCARD_REWARD_PRODUCTS = "searchPostcardRewardProducts",
  GET_POSTCARD_REWARD_LOGS = "getPostcardRewardLogs",
  GET_POSTCARD_REWARD_STATS = "getPostcardRewardStats",
  DISTRIBUTE_POSTCARD_REWARDS = "distributePostcardRewards",
  RETRY_FAILED_POSTCARD_REWARDS = "retryFailedPostcardRewards",
  RETRY_POSTCARD_REWARD_LOG = "retryPostcardRewardLog",

  // 抽卡系统 - 卡牌系列
  GET_CARD_SERIES_LIST = "getCardSeriesList",
  GET_CARD_SERIES = "getCardSeries",
  CREATE_CARD_SERIES = "createCardSeries",
  UPDATE_CARD_SERIES = "updateCardSeries",
  DELETE_CARD_SERIES = "deleteCardSeries",
  GET_ALL_CARD_SERIES = "getAllCardSeries",

  // 抽卡系统 - 稀有度
  GET_CARD_RARITY_LIST = "getCardRarityList",
  GET_CARD_RARITY = "getCardRarity",
  CREATE_CARD_RARITY = "createCardRarity",
  UPDATE_CARD_RARITY = "updateCardRarity",
  DELETE_CARD_RARITY = "deleteCardRarity",
  GET_ALL_CARD_RARITIES = "getAllCardRarities",

  // 抽卡系统 - 语系
  GET_CARD_LANGUAGE_LIST = "getCardLanguageList",
  GET_CARD_LANGUAGE = "getCardLanguage",
  CREATE_CARD_LANGUAGE = "createCardLanguage",
  UPDATE_CARD_LANGUAGE = "updateCardLanguage",
  DELETE_CARD_LANGUAGE = "deleteCardLanguage",
  GET_ALL_CARD_LANGUAGES = "getAllCardLanguages",

  // 抽卡系统 - 版本
  GET_CARD_VERSION_LIST = "getCardVersionList",
  GET_CARD_VERSION = "getCardVersion",
  CREATE_CARD_VERSION = "createCardVersion",
  UPDATE_CARD_VERSION = "updateCardVersion",
  DELETE_CARD_VERSION = "deleteCardVersion",
  GET_ALL_CARD_VERSIONS = "getAllCardVersions",

  // 抽卡系统 - 卡牌
  GET_CARDS = "getCards",
  GET_CARD = "getCard",
  CREATE_CARD = "createCard",
  UPDATE_CARD = "updateCard",
  DELETE_CARD = "deleteCard",
  GET_ALL_CARDS = "getAllCards",
  GET_CARD_RARITIES = "getCardRarities",
  DOWNLOAD_CARDS = "downloadCards",
  UPLOAD_CARDS = "uploadCards",
  UPLOAD_CARD_IMAGES = "uploadCardImages",
  GET_CARD_IMAGES_UPLOAD_STATUS = "getCardImagesUploadStatus",
  UPLOAD_PRODUCT_IMAGES = "uploadProductImages",
  GET_PRODUCT_IMAGES_UPLOAD_STATUS = "getProductImagesUploadStatus",

  // 抽卡系统 - 卡池
  GET_CARD_POOLS = "getCardPools",
  GET_CARD_POOL = "getCardPool",
  CREATE_CARD_POOL = "createCardPool",
  UPDATE_CARD_POOL = "updateCardPool",
  DELETE_CARD_POOL = "deleteCardPool",
  GET_ALL_CARD_POOLS = "getAllCardPools",
  GET_CARD_POOL_PROBABILITY = "getCardPoolProbability",

  // 抽卡系统 - 卡池项目
  GET_CARD_POOL_ITEMS = "getCardPoolItems",
  CREATE_CARD_POOL_ITEM = "createCardPoolItem",
  BATCH_CREATE_CARD_POOL_ITEMS = "batchCreateCardPoolItems",
  UPDATE_CARD_POOL_ITEM = "updateCardPoolItem",
  DELETE_CARD_POOL_ITEM = "deleteCardPoolItem",
  BATCH_UPDATE_CARD_POOL_ITEMS = "batchUpdateCardPoolItems",

  // 抽卡系统 - 抽卡记录
  GET_CARD_DRAW_RECORDS = "getCardDrawRecords",
  GET_CARD_DRAW_RECORD = "getCardDrawRecord",
  GET_CARD_DRAW_STATISTICS = "getCardDrawStatistics",

  // 对对碰系统 - 池子管理
  GET_MATCH_POOLS = "getMatchPools",
  GET_MATCH_POOL = "getMatchPool",
  CREATE_MATCH_POOL = "createMatchPool",
  UPDATE_MATCH_POOL = "updateMatchPool",
  DELETE_MATCH_POOL = "deleteMatchPool",
  GET_ALL_MATCH_POOLS = "getAllMatchPools",
  GET_MATCH_POOL_STATS = "getMatchPoolStats",
  SIMULATE_MATCH_POOL = "simulateMatchPool",
  SIMULATE_BOX_INFO = "simulateBoxInfo",
  SIMULATE_CARD_POOL = "simulateCardPool",
  DUPLICATE_CARD_POOL = "duplicateCardPool",
  ARRIVE_CARD_POOL = "arriveCardPool",

  // 对对碰系统 - 游戏记录
  GET_MATCH_GAME_RECORDS = "getMatchGameRecords",
  GET_MATCH_GAME_RECORD = "getMatchGameRecord",

  // 资产法盈亏排行
  GET_ASSET_LOSER_ITEMS = "getAssetLoserItems",
  GET_DOWNLOAD_ASSET_LOSER_ITEMS = "getDownloadAssetLoserItems",

  // 冲冲赏记录
  GET_RUN_GIFT_RECORDS = "getRunGiftRecords",

  // 吃菜/做菜记录
  GET_PRODUCT_GIFT_RECORDS = "getProductGiftRecords",
  GET_PRODUCT_GIFT_RECORD_RANKING = "getProductGiftRecordRanking",

}

enum Mutations {
  // mutation types
  SET_CLASSNAME_BY_POSITION = "appendBreadcrumb",
  PURGE_AUTH = "logOut",
  SET_AUTH = "setAuth",
  SET_USER = "setUser",
  SET_PASSWORD = "setPassword",
  SET_ERROR = "setError",
  SET_BREADCRUMB_MUTATION = "setBreadcrumbMutation",
  SET_LAYOUT_CONFIG = "setLayoutConfig",
  RESET_LAYOUT_CONFIG = "resetLayoutConfig",
  OVERRIDE_LAYOUT_CONFIG = "overrideLayoutConfig",
  OVERRIDE_PAGE_LAYOUT_CONFIG = "overridePageLayoutConfig",
  SET_SHOPS = "setShops",
  SET_SHOP_COUNT = "setShopCount",
  SET_SHOP = "setShop",
  SET_BUSINESS_DISTRICTS = "setBusinessDistricts",
  SET_BUSINESS_DISTRICT_COUNT = "setBusinessDistrictCount",
  SET_BUSINESS_DISTRICT = "setBusinessDistrict",
  SET_ADMINS = "setAdmins",
  SET_ADMIN_COUNT = "setAdminCount",
  SET_ADMIN = "setAdmin",
  SET_DISTRIBUTION_USERS = "setDistributionUsers",
  SET_DISTRIBUTION_USER_COUNT = "setDistributionUserCount",
  SET_DISTRIBUTIONS = "setDistributions",
  SET_DISTRIBUTION_COUNT = "setDistributionCount",
  SET_DISTRIBUTION = "setDistribution",
  SET_ORDERS = "setOrders",
  SET_ORDER_COUNT = "setOrderCount",
  SET_ORDER = "setOrder",
  SET_USERS = "setUsers",
  SET_USER_COUNT = "setUserCount",
  SET_BUDGET_YEARS = "setBudgetYears",
  SET_BUDGET_YEAR_OPTIONS = "setBudgetYearOptions",
  SET_BUDGET_YEAR = "setBudgetYear",
  SET_BUDGET_QUARTERS = "setBudgetQuarters",
  SET_BUDGET_QUARTER = "setBudgetQuarter",
  SET_SHIFT_BY_BUDGET_QUARTERS = "setShiftByBudgetQuarters",
  SET_COUPON_ITEMS = "setCouponItems",
  SET_COUPON_ITEM_COUNT = "setCouponItemCount",
  SET_COUPON_ITEM = "setCouponItem",
  SET_COUPON_DELIVER_EVENTS = "setCouponDeliverEvents",
  SET_COUPON_DELIVER_EVENT = "setCouponDeliverEvent",
  SET_COUPON_SETTINGS = "setCouponSettings",
  SET_COUPON_DELIVER_EVENT_ITEMS = "setCouponDeliverEventItems",
  SET_EVENTS = "setEvents",
  SET_EVENT_COUNT = "setEventCount",
  SET_EVENT = "setEvent",
  SET_ROLES = "getRoles",
  SET_ROLE_COUNT = "setRoleCount",
  SET_SHOP_LOGIN = "setShopLogin",
  SET_EVENT_INVITATIONS = "setEventInvitations",
  SET_SYSTEM_SETTING = "set_system_setting",
  SET_GIFT_COUPONS = "set_gift_coupons",
  SET_EVENT_INVITATION_COUNT = "set_event_invitation_count",
  SET_EVENT_REGISTRATIONS = "set_event_registrations",
  SET_EVENT_REGISTRATION_COUNT = "set_event_registration_count",
  SET_NEWS_ITEMS = "setNewsItems",
  SET_NEWS_ITEM_COUNT = "setNewsItemCount",
  SET_NEWS_ITEM = "setNewsItem",

  SET_MEMBERS = "setMembers",
  SET_MEMBER_COUNT = "setMemberCount",
  SET_MEMBER = "setMember",

  SET_REPORT_DAY = "setReportDay",
  SET_REPORT_DAYS = "setReportDays",
  SET_REPORT_DAY_COUNT = "setReportDayCount",

  SET_PRODUCT_BRANDS = "setProductBrands",
  SET_PRODUCT_BRAND_COUNT = "setProductBrandCount",
  SET_PRODUCT_BRAND = "setProductBrand",
  SET_COMPOUND_CATEGORIES = "setCompoundCategories",
  SET_COMPOUND_CATEGORY_COUNT = "setCompoundCategoryCount",
  SET_COMPOUND_CATEGORY = "setCompoundCategory",
  SET_LOTTERY_SIGNS = "setLotterySigns",
  SET_LOTTERY_SIGN = "setLotterySign",
  SET_COMPOUNDS = "setCompounds",
  SET_COMPOUND_COUNT = "setCompoundCount",
  SET_COMPOUND = "setCompound",
  SET_IPS = "setIps",
  SET_IP_COUNT = "setIpCount",
  SET_IP = "setIp",
  SET_PRODUCTS = "setProducts",
  SET_ALL_PRODUCTS = "setAllProducts",
  SET_PRODUCT_COUNT = "setProductCount",
  SET_PRODUCT = "setProduct",
  SET_DOWNLOAD_PRODUCTS = "setDownloadProducts",
  SET_DOWNLOAD_PAYMENT_RECORDS = "setDownloadPaymentRecords",
  SET_DOWNLOAD_ADD_BALANCE_RECORDS = "setDownloadAddBalanceRecords",
  SET_DOWNLOAD_GIFT_RECORDS = "setDownloadGiftRecords",
  SET_DOWNLOAD_MEMBERS = "setDownloadMembers",
  SET_DOWNLOAD_LOSER_ITEMS = "setDownloadLoserItems",
  SET_BOX_INFOS = "setBoxInfos",
  SET_BOX_INFO_COUNT = "setBoxInfoCount",
  SET_BOX_INFO = "setBoxInfo",
  SET_BOX_TYPES = "setBoxTypes",
  SET_GAME_TYPES = "setGameTypes",
  SET_BOX_ITEM_LEVELS = "setBoxItemLevels",
  SET_BOX_ITEM_TYPES = "setBoxItemTypes",
  SET_BOX_LEVEL_TYPES = "setBoxLevelTypes",
  SET_BOX_LEVEL_ITEM_INFO_GIFT_TYPES = "setBoxLevelItemInfoGiftTypes",
  SET_BOXES = "setBoxes",
  SET_BOX_COUNT = "setBoxCount",
  SET_BOX_RECORDS = "setBoxRecords",
  SET_BOX_RECORD_COUNT = "setBoxRecordCount",

  SET_BOX_CATEGORIES = "setBoxCategories",
  SET_BOX_CATEGORY_COUNT = "setBoxCategoryCount",
  SET_BOX_CATEGORY = "setBoxCategory",

  SET_PRODUCT_BRAND_OPTIONS = "setProductBrandOptions",
  SET_PRODUCT_IP_OPTIONS = "setProductIpOptions",
  SET_PRODUCT_RECYCLE_TYPE_OPTIONS = "setProductRecycleTypeOptions",
  SET_BANNERS = "setBanners",

  SET_BOX_INFO_BOX_TYPE_OPTIONS = "setBoxInfoBoxTypeOptions",

  SET_REMOVE_BALANCE_RECORDS = "setRemoveBalanceRecords",
  SET_REMOVE_BALANCE_RECORD_COUNT = "setRemoveBalanceRecordCount",
  SET_REMOVE_BALANCE_RECORD = "setRemoveBalanceRecord",
  SET_PAYMENT_RECORDS = "setPaymentRecords",
  SET_PAYMENT_RECORD_COUNT = "setPaymentRecordCount",
  SET_ADD_BALANCE_RECORDS = "setAddBalanceRecords",
  SET_ADD_BALANCE_RECORD_COUNT = "setAddBalanceRecordCount",
  SET_ADD_BALANCE_RECORD = "setAddBalanceRecord",
  SET_OPERATING_COSTS = "setOperatingCosts",
  SET_OPERATING_COST_COUNT = "setOperatingCostCount",
  SET_OPERATING_COST_TOTAL_AMOUNT = "setOperatingCostTotalAmount",
  SET_OPERATING_COST = "setOperatingCost",
  SET_OPERATING_COST_MONTHLY_SUMMARY = "setOperatingCostMonthlySummary",
  SET_DOWNLOAD_ADD_POINT_RECORDS = "setDownloadAddPointRecords",
  SET_ADD_POINT_RECORDS = "setAddPointRecords",
  SET_ADD_POINT_RECORD_COUNT = "setAddPointRecordCount",
  SET_ADD_POINT_RECORD = "setAddPointRecord",
  SET_ADD_EXTRA_POINT_RECORDS = "setAddExtraPointRecords",
  SET_ADD_EXTRA_POINT_RECORD_COUNT = "setAddExtraPointRecordCount",
  SET_ADD_EXTRA_POINT_RECORD = "setAddExtraPointRecord",
  SET_SHIPPING_ORDERS = "setShippingOrders",
  SET_SHIPPING_ORDER_COUNT = "setShippingOrderAddPointRecordCount",
  SET_SHIPPING_ORDER = "setShippingOrder",
  SET_SUMMARY = "setSummary",
  SET_WATER_LIST = "setWaterList",
  SET_LOSER_LIST = "setLoserList",
  SET_CARD_RECORDS = "setCardRecords",
  SET_CARD_RECORD_COUNT = "setCardRecordCount",
  SET_WATER_ITEMS = "setWaterItems",
  SET_WATER_ITEM_COUNT = "setWaterItemCount",
  SET_LOSER_ITEMS = "setLoserItems",
  SET_LOSER_ITEM_COUNT = "setLoserItemCount",
  SET_EVENT_OPTIONS = "setEventOptions",
  SET_BOX_PRODUCTS = "setBoxProducts",
  SET_LEVELS = "setLevels",
  SET_GIFT_RECORD = "setGiftRecord",
  SET_GIFT_RECORDS = "setGiftRecords",
  SET_GIFT_RECORD_COUNT = "setGiftRecordCount",
  SET_RELATIVE_BOX_INFOS = "setRelativeBoxInfos",
  SET_SHIPPING_PRODUCTS = "setShippingProducts",
  SET_SHIPPING_PRODUCTS_LOADING = "setShippingProductsLoading",
  SET_POCKET_ITEMS = "setPocketItems",
  SET_POCKET_ITEM_COUNT = "setPocketItemCount",
  SET_POCKET_ITEMS_LOADING = "setPocketItemsLoading",
  SET_SHIPPING_RECORDS = "SET_SHIPPING_RECORDS",
  SET_SHIPPING_RECORDS_LOADING = "SET_SHIPPING_RECORDS_LOADING",
  SET_COMPOUND_RECORDS = "setCompoundRecords",
  SET_COMPOUND_RECORDS_COUNT = "setCompoundRecordsCount",
  SET_USER_PENDING_DETAILS = "setUserPendingDetails",
  SET_USER_PENDING_LOADING = "setUserPendingLoading",

  // 商城订单相关
  SET_MALL_ORDERS = "setMallOrders",
  SET_MALL_ORDER_COUNT = "setMallOrderCount",
  SET_MALL_PRODUCTS = "setMallProducts",
  SET_MALL_PRODUCT_COUNT = "setMallProductCount",
  SET_MALL_ORDER = "setMallOrder",
  SET_DOWNLOAD_MALL_ORDERS = "setDownloadMallOrders",

  // 商城优惠券相关
  SET_MALL_COUPONS = "setMallCoupons",
  SET_MALL_COUPON = "setMallCoupon",
  SET_MALL_COUPON_COUNT = "setMallCouponCount",
  SET_MALL_COUPON_USAGE = "setMallCouponUsage",

  // 抽赏优惠券相关
  SET_LOTTERY_COUPONS = "setLotteryCoupons",
  SET_LOTTERY_COUPON = "setLotteryCoupon",
  SET_LOTTERY_COUPON_COUNT = "setLotteryCouponCount",
  SET_LOTTERY_COUPON_USAGE = "setLotteryCouponUsage",
  SET_LOTTERY_COUPON_BOX_INFOS = "setLotteryCouponBoxInfos",

  // 明信片奖励相关
  SET_POSTCARD_REWARD_CONFIGS = "setPostcardRewardConfigs",
  SET_POSTCARD_REWARD_CONFIG = "setPostcardRewardConfig",
  SET_POSTCARD_REWARD_CONFIG_COUNT = "setPostcardRewardConfigCount",
  SET_POSTCARD_REWARD_LOGS = "setPostcardRewardLogs",
  SET_POSTCARD_REWARD_LOG = "setPostcardRewardLog",
  SET_POSTCARD_REWARD_LOG_COUNT = "setPostcardRewardLogCount",
  SET_POSTCARD_REWARD_STATS = "setPostcardRewardStats",
  SET_POSTCARD_REWARD_OPTIONS = "setPostcardRewardOptions",

  // 抽卡系统 - 卡牌系列
  SET_CARD_SERIES_LIST = "setCardSeriesList",
  SET_CARD_SERIES = "setCardSeries",
  SET_CARD_SERIES_COUNT = "setCardSeriesCount",
  SET_ALL_CARD_SERIES = "setAllCardSeries",

  // 抽卡系统 - 稀有度
  SET_CARD_RARITY_LIST = "setCardRarityList",
  SET_CARD_RARITY = "setCardRarity",
  SET_CARD_RARITY_COUNT = "setCardRarityCount",
  SET_ALL_CARD_RARITIES = "setAllCardRarities",

  // 抽卡系统 - 语系
  SET_CARD_LANGUAGE_LIST = "setCardLanguageList",
  SET_CARD_LANGUAGE = "setCardLanguage",
  SET_CARD_LANGUAGE_COUNT = "setCardLanguageCount",
  SET_ALL_CARD_LANGUAGES = "setAllCardLanguages",

  // 抽卡系统 - 版本
  SET_CARD_VERSION_LIST = "setCardVersionList",
  SET_CARD_VERSION = "setCardVersion",
  SET_CARD_VERSION_COUNT = "setCardVersionCount",
  SET_ALL_CARD_VERSIONS = "setAllCardVersions",

  // 抽卡系统 - 卡牌
  SET_CARDS_LIST = "setCardsList",
  SET_CARD = "setCard",
  SET_CARDS_COUNT = "setCardsCount",
  SET_ALL_CARDS = "setAllCards",
  SET_CARD_RARITIES = "setCardRarities",
  SET_DOWNLOAD_CARDS = "setDownloadCards",

  // 抽卡系统 - 卡池
  SET_CARD_POOLS_LIST = "setCardPoolsList",
  SET_CARD_POOL = "setCardPool",
  SET_CARD_POOLS_COUNT = "setCardPoolsCount",
  SET_ALL_CARD_POOLS = "setAllCardPools",
  SET_CARD_POOL_PROBABILITY = "setCardPoolProbability",

  // 抽卡系统 - 卡池项目
  SET_CARD_POOL_ITEMS = "setCardPoolItems",

  // 抽卡系统 - 抽卡记录
  SET_CARD_DRAW_RECORDS_LIST = "setCardDrawRecordsList",
  SET_CARD_DRAW_RECORD = "setCardDrawRecord",
  SET_CARD_DRAW_RECORDS_COUNT = "setCardDrawRecordsCount",
  SET_CARD_DRAW_STATISTICS = "setCardDrawStatistics",

  // 对对碰系统 - 池子管理
  SET_MATCH_POOLS_LIST = "setMatchPoolsList",
  SET_MATCH_POOL = "setMatchPool",
  SET_MATCH_POOLS_COUNT = "setMatchPoolsCount",
  SET_ALL_MATCH_POOLS = "setAllMatchPools",
  SET_MATCH_POOL_STATS = "setMatchPoolStats",

  // 对对碰系统 - 游戏记录
  SET_MATCH_GAME_RECORDS_LIST = "setMatchGameRecordsList",
  SET_MATCH_GAME_RECORD = "setMatchGameRecord",
  SET_MATCH_GAME_RECORDS_COUNT = "setMatchGameRecordsCount",

  // 资产法盈亏排行
  SET_ASSET_LOSER_ITEMS = "setAssetLoserItems",
  SET_ASSET_LOSER_ITEM_COUNT = "setAssetLoserItemCount",
  SET_DOWNLOAD_ASSET_LOSER_ITEMS = "setDownloadAssetLoserItems",

  // 冲冲赏记录
  SET_RUN_GIFT_RECORDS_LIST = "setRunGiftRecordsList",
  SET_RUN_GIFT_RECORDS_COUNT = "setRunGiftRecordsCount",

  // 吃菜/做菜记录
  SET_PRODUCT_GIFT_RECORDS_LIST = "setProductGiftRecordsList",
  SET_PRODUCT_GIFT_RECORDS_COUNT = "setProductGiftRecordsCount",
  SET_PRODUCT_GIFT_RECORD_RANKING = "setProductGiftRecordRanking",
  SET_PRODUCT_GIFT_RECORD_RANKING_COUNT = "setProductGiftRecordRankingCount",

}

export { Actions, Mutations };
